<div class="c-container">
    <div class="row align-items-center no-gutters">
        <div class="col-6 col-md-6 col-lg-6">
            <h1 class="chatHeading text-secondary" [style.color]="settingsData?.event_font_main_color + '!important'">Private Chat</h1>
        </div>
        <div class="col-6 col-md-6 col-lg-6 text-right">
            <input type="text" class="s-box secondary-bg-font-color1 bg-secondary" [(ngModel)]="searchContact"
                placeholder="Search">
            <i class="fa fa-search s-icon text-white" aria-hidden="true"></i>
        </div>
    </div>
    <div class="row chat-box no-gutters">
        <div class="col-12 col-md-5 col-lg-5 ">
            <div class="chat-profiles bg-dark mr-30" [style.color]="settingsData?.event_font_secondary_color + '!important'" 
            [style.background-color]="settingsData?.event_bg_secondary_color +'!important'">
                <!-- <div class="row notification">
                    <div class="col-8 col-md-8 col-lg-8">
                        <h2 class="notification-heading text-secondary">Notifications Sound</h2>
                    </div>
                    <div class="col-4 col-md-4 col-lg-4">

                    </div>
                </div> -->
                <ng-container *ngIf="( fansList | filter : searchContact:'name') as fanData">
                <div class=" row align-items-center chat-profile no-gutters pointer" [ngClass]="{'active':fan.isActive}" [style.--active-bg]="settingsData?.event_bg_primary_color"
                    *ngFor="let fan of fanData | filter: searchContact:'name'" (click)="startChat(fan)">
                    <div class="col-4 col-md-4 col-lg-3">
                        <div class="profile-image-container text-center" *ngIf="fan?.profile_pic; else userName">
                            <img class="roundUserImage" src="{{fan?.profile_pic}}">
                        </div>
                        <ng-template #userName>
                            <div class="profile-image-container text-center"
                                [ngStyle]="{'background-color': fan?.userColor }">
                                <span class="text-uppercase name text-white notranslate">{{fan?.shortName}}</span>
                            </div>
                        </ng-template>
                    </div>
                    <div class="col-8 col-md-8 col-lg-9">
                        <div class="row no-gutters align-items-center">
                            <div class="col-9 col-md-9 col-lg-10 ">
                                <div class="profile-name text-secondary" [style.color]="settingsData?.event_font_secondary_color + '!important'" >{{fan.name}}</div>
                            </div>
                            <div class="col-3 col-md-3 col-lg-2 text-right">
                                <div class="date text-secondary notranslate" [style.color]="settingsData?.event_font_secondary_color + '!important'" >{{fan.createdAt}}</div>
                            </div>
                        </div>
                        <div class="messege text-secondary" [style.color]="settingsData?.event_font_secondary_color + '!important'" >{{fan.message}}</div>
                    </div>
                </div>
                <div *ngIf="fanData.length == 0 && isDataLoaded" class="text-center w-100 p-20" [style.color]="settingsData?.event_font_secondary_color + '!important'" >No records found</div> 
            </ng-container>
            </div>
        </div>
        <div fxLayout="column" class="col-12 col-md-7 col-lg-7 chat-area live-chat bg-dark"
        [style.background-color]="settingsData?.event_bg_secondary_color + '!important'"
        [style.color]="settingsData?.event_font_secondary_color + '!important'"
            *ngIf="contactData && contactData.name">
            <div class="row chat-header no-gutters" [style.border-bottom]="'1px solid' + settingsData?.event_font_secondary_color + '!important'">
                <div class="col-11 pt-11 text-secondary" [style.color]="settingsData?.event_font_secondary_color + '!important'">
                    <span *ngIf="toggleViewContact"><i class="fa fa-angle-left pointer fs-16 pr-15 pt-13" aria-hidden="true"
                        (click)="backToContact()"></i></span>{{contactData?.name}}
                </div>
                <div class="col-1 text-right">
                    <button mat-icon-button [matMenuTriggerFor]="menu" class="menu-icon" [ngStyle]="{'color':settingsData?.event_font_secondary_color}" >
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" backdropClass="custom-menu" >
                        <ng-container>
                            <button mat-menu-item (click)="viewContact('fans')" [style.color]="settingsData?.event_font_primary_color + '!important'"
                            *ngIf="contactData?.accepted && contactData?.accepted.indexOf(userInfo.id) != -1">
                            <span [ngClass]="{'c-p':toggleViewContact}">View Contact</span>
                        </button>
                        <button mat-menu-item (click)="sendRequest(contactData)" [style.color]="settingsData?.event_font_primary_color + '!important'"
                            *ngIf="contactData?.sent && contactData?.sent.indexOf(userInfo.id) == -1 && contactData?.received.indexOf(userInfo.id) == -1 && contactData?.accepted.indexOf(userInfo.id) == -1 && contactData?.rejected.indexOf(userInfo.id) == -1 && !contactData?.disableContact">
                            <span [ngClass]="{'c-p':toggleViewContact}">Send Request</span>
                        </button>
                        <button mat-menu-item disabled [style.color]="settingsData?.event_font_primary_color + '!important'"
                            *ngIf="(contactData?.received && contactData?.received.indexOf(userInfo.id) != -1 && contactData?.accepted && contactData?.accepted.indexOf(userInfo.id) == -1) || (contactData?.rejected && contactData?.rejected.indexOf(userInfo.id) != -1) || (contactData?.disableContact)">
                            <span [ngClass]="{'c-p':toggleViewContact}">Contact Received</span>
                        </button>
                            <!-- <button mat-menu-item (click)="blockContact()">
                                <span>Block</span>
                            </button> -->
                            <button mat-menu-item (click)="clearChatHistory()" *ngIf="messageList && messageList.length > 0" hidden>
                                <span>Clear Conversation</span>
                            </button>
                        </ng-container>
                    </mat-menu>
                </div>
            </div>
            <ng-container *ngIf="!toggleViewContact">
            <ng-container *ngIf="isCheckingChannel; else contentLoading">
                <div class="w-100 chat-box mt-0">
                    <div id="pc-chat-inner-box" class="chat-inner-box plr-15 messege-area"
                        [ngClass]="{'pc-inner-box':contactInfo && contactInfo?.name}">
                        <ng-container *ngFor="let a of messageList;">
                            <div>
                                <div class="from-messege-div text-left"
                                    [ngClass]="{'my-messege-div text-right ':(a.isSender || a._sender?.isSender)}">
                                    <div class="messege mt-20 "
                                        [style.--message-bg]="settingsData?.event_button_bg_primary_color "
                                        [style.--message-font]="settingsData?.event_button_font_primary_color "
                                        [ngClass]="{'my-messege text-secondary':(a.isSender || a._sender?.isSender)}"
                                        [style.--my-messege-bg]="settingsData?.event_button_bg_secondary_color"
                                        [style.--my-messege-font]="settingsData?.event_button_font_secondary_color"
                                        [innerHTML]="a.message">
                                    </div>
                                    <span class="sent-time"
                                    [style.--sent-time]="settingsData?.event_button_font_primary_color"
                                    [style.--active-time]="settingsData?.event_button_font_secondary_color"
                                        [ngClass]="{'text-white':(a.isSender || a._sender?.isSender)}">{{a.time}}</span>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
            <ng-template #contentLoading>
                <div fxFlex="100%" class="mt-10">
                    <content-loading [width]="'width85Per'"></content-loading>
                    <content-loading [width]="'width65Per'"></content-loading>
                    <content-loading [width]="'width45Per'"></content-loading>
                    <content-loading [width]="'width30Per'"></content-loading>
                    <content-loading [width]="'width45Per'"></content-loading>
                    <content-loading [width]="'width85Per'"></content-loading>
                    <content-loading [width]="'width65Per'"></content-loading>
                    <content-loading [width]="'width45Per'"></content-loading>
                    <content-loading [width]="'width30Per'"></content-loading>
                    <content-loading [width]="'width85Per'"></content-loading>
                    <content-loading [width]="'width65Per'"></content-loading>
                    <content-loading [width]="'width45Per'"></content-loading>
                    <content-loading [width]="'width30Per'"></content-loading>
                </div>
            </ng-template>
            <div class="send-messege" [ngStyle]="{'background-color':settingsData?.event_bg_primary_color}">
                <div class="row align-items-center no-gutters">
                    <div class="col-3 col-md-2 col-lg-1 pl-10">
                        <i class="fa fa-smile-o secondary-bg-font-color1 fs-20 icon" *ngIf="!isShowEmoji" aria-hidden="true"
                            (click)="openCloseEmoji()"></i>
                        <i class="fa fa-angle-down icon" *ngIf="isShowEmoji" aria-hidden="true"
                            (click)="openCloseEmoji()"></i>
                    </div>
                    <div class="col-6 col-md-8 col-lg-10"
                        [ngClass]="{'pad-msg':sendMessageText =='' || sendMessageText.length <= 145}">
                        <textarea placeholder="Send a message" id="privateMsg" (ngModelChange)="sendMsg($event)" [style.--place-holder]="settingsData?.event_font_primary_color "
                            [(ngModel)]="sendMessageText" class="fs-15 chat-message-box w-100" [style.color]="settingsData?.event_font_primary_color +'!important'"
                            (keydown.enter)="sendMessage()"></textarea>
                    </div>
                    <div class="col-3 col-md-2 col-lg-1 text-center text-info">
                        <span class="material-icons pointer notranslate fs-20" (click)="sendMessage()" [style.color]="settingsData?.event_button_bg_primary_color +'!important'">
                            send
                        </span>
                    </div>
                    <div [ngClass]="{'emojiShow': isShowEmoji,  'emojiNone': !isShowEmoji }">
                        <emoji-mart [showPreview]="false" [isNative]="true" [set]="native"
                            (emojiClick)="addEmoji($event)" [showSingleCategory]="false"
                            [emojisToShowFilter]="filterEmoji" [enableSearch]="false"
                            [style]="{ width: '300px',position: 'absolute', bottom: '60px', left: '20px' }">
                        </emoji-mart>
                    </div>
                </div>
            </div>
        </ng-container>
            <ng-container *ngIf="toggleViewContact">
                <!-- <div class="d-contents"> -->
                <div fxLayout="column" class="w-100">
                    <div *ngIf="contactData.contact_details.profile_pic; else defaultPic">
                        <img class="user-profile" src="{{contactData.contact_details.profile_pic}}">
                    </div>
                    <ng-template #defaultPic>
                        <!-- <div class="user-profile"> -->
                        <img class="user-profile" [src]="assets_url + 'default.png'">
                        <!-- </div> -->
                    </ng-template>
                    <div class="pl-20">
                    <h1 class="ff fs-20 text-capitalize mb-0 pb-5">{{contactData.contact_details.name}}</h1>
                    <p *ngIf="contactData?.contact_details?.email"><span><i class="fa fa-envelope cont-icon pr-10"
                                aria-hidden="true"></i>
                            <span class="fs-16"
                                *ngIf="contactData?.contact_details?.email.length < 28">{{contactData?.contact_details?.email}}</span>
                            <span class="fs-16" *ngIf="contactData?.contact_details?.email.length >= 28"
                                matTooltipPosition="above"
                                matTooltip="{{contactData?.contact_details?.email}}">{{contactData?.contact_details?.email|limitTo:28}}...</span></span>
                    </p>
                    <p
                        *ngIf="contactData?.contact_details.phone_number && contactData?.contact_details?.phone_number.length > 5">
                        <i class="fa fa-phone pr-10"
                            aria-hidden="true"></i>{{contactData?.contact_details?.phone_number}}
                    </p>
                </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>